const PersonIcon = () => (
    <svg
        width="100%"
        height="100%"
        viewBox="0 0 138 138"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M69 83.75C84.5 83.75 96.125 72.125 96.125 56.625C96.125 41.125 84.5 29.5 69 29.5C53.5 29.5 41.875 41.125 41.875 56.625C41.875 72.125 53.5 83.75 69 83.75Z"
            stroke="#C6D4F9"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M25.5 120C25.5 94.875 47.75 86.5 69 86.5C90.25 86.5 112.5 94.875 112.5 120"
            stroke="#C6D4F9"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default PersonIcon;
